import React, { FC } from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbComponentProps {
}

const BreadcrumbComponent: FC<BreadcrumbComponentProps> = () => {
    const location = useLocation();

    return (
        <MuiLink
            data-testid="BreadcrumbComponent"
            component={Link}
            to={`/${location.search}`}
            sx={{ fontSize: '15px', fontFamily: 'Roboto' }}
        >
            Scan overview
        </MuiLink>
    );
};

export default BreadcrumbComponent;
